module.exports = __webpack_public_path__ + "img/twint.a82c442a.svg";